// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useRef, ReactNode, useEffect } from "react";

// SVG's
import CloseIcon from '@/public/svg/close.svg';

// styles
import styles from './Modal.module.scss';
export interface ModalProps {
  isOpen: boolean;
  children: ReactNode;
  className?: string;
  innerClassName?: string;
  onClose?: () => void; // Fires on any modal close action (background click, escape key, close button)
  onCloseButtonClick?: () => void; // Only fires when the close button is clicked
  onModalBackgroundClick?: () => void; // Only fires when the modal background is clicked
  onEscapeKeyPress?: () => void; // Only fires when the escape key is pressed
}

function Modal(props: ModalProps) {
  const { isOpen, className, innerClassName, children, onClose, onCloseButtonClick, onModalBackgroundClick, onEscapeKeyPress } = props;
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if(isOpen) {
      // Only call showModal if dialog is not already open
      if (dialogRef.current && !dialogRef.current?.open) {
        dialogRef.current?.showModal?.();
      }
    } else {
      // Only call close if dialog is actually open
      if (dialogRef.current?.open) {
        dialogRef.current?.close?.();
      }
    }
  }, [isOpen])

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    
    // Guard against closing an already-closed dialog
    if (dialogRef.current?.open) {
      dialogRef.current.close();
    }
  }

  const handleCloseButtonClick = () => {
    if (onCloseButtonClick) {
      onCloseButtonClick()
    }

    handleClose();
  }

  const handleEscapeKeyPress = (e: React.SyntheticEvent) => {
    // Prevent the browser's default close behavior to avoid double-close
    e.preventDefault();
    
    if (onEscapeKeyPress) {
      onEscapeKeyPress();
    }

    handleClose();
  }

  // this allows for click on the background and dismissing the modal
  const handleModalBackgroundClick = (e: React.MouseEvent<HTMLDialogElement>) => {
    const target = e.target as HTMLElement;

    if (target === dialogRef.current) {
      if(onModalBackgroundClick) {
        onModalBackgroundClick();
      }
      handleClose();
    }
  };

  let classNames = `${styles.modal}`;

  if (className) {
    classNames += ` ${className}`;
  }

  return (
    <dialog
      ref={dialogRef}
      className={classNames}
      onCancel={handleEscapeKeyPress}
      onClick={handleModalBackgroundClick}
    >
    {/* This inner div is necessary so that clicking inside the dialog
    doesn't dismiss the modal. */}
      <div className={innerClassName}>
        {children}

        <button
          className={styles.btn__close}
          onClick={handleCloseButtonClick}
          aria-label='Close'
        >
          <CloseIcon />
        </button>
      </div>
    </dialog>
  )
}

export default Modal
